import React, { Component } from 'react'
import PlotPolygon from './PlotPolygon'
//import {PlotModule} from './PlotModule'
import Control from 'react-leaflet-control'
import { withTranslation } from 'react-i18next'
// import { ReactComponent as Svg } from 'Resources/Icons/fence-left-image.svg'
import { ReactComponent as ModeOn } from 'Resources/Icons/fencesEditMode.svg'
import { ReactComponent as ModeOff } from 'Resources/Icons/fencesEditModeOff.svg'
import ErrorBoundary from 'Utils/ErrorBoundary/ErrorBoundary'
import MapButton from 'Utils/components/MapButton'
import { toggle } from 'Store/actions/toggle-action'
import { connect } from 'react-redux'
import { canAccess } from 'Utils/rbac'

class MapTools extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toolButtonTitle: props.t('DrawTool'),
      errorBoundaryKey: 0,
    }
  }

  showToolsButton = () => {
    this.props.toggle('fencesEditionMode')
    this.setState({ show: !this.state.show })
  }

  handleRerender = () => {
    if (this.state.errorBoundaryKey < 5)
      this.setState((prevState) => ({
        errorBoundaryKey: prevState.errorBoundaryKey + 1,
      }))
  }

  render() {
    const { t, scope, fencesEditionMode } = this.props

    return (
      <div className="divFenceButton">
        <Control position={'topright'} style={{ top: '90px' }}>
          {canAccess({ actions: 'WRITE', roles: scope }) && (
            <MapButton position="topright" onClick={this.showToolsButton}>
              {fencesEditionMode ? (
                <ModeOn title={t('Desativar Modo de Edição')} />
              ) : (
                <ModeOff title={t('Ativar Modo de Edição')} />
              )}
            </MapButton>
          )}
        </Control>
        <ErrorBoundary key={this.state.errorBoundaryKey} onError={this.handleRerender}>
          <PlotPolygon showToolsButton={this.showToolsButton} show={fencesEditionMode} refMap={this.props.refMap} />
        </ErrorBoundary>
      </div>
    )
  }
}
const mapStateToProps = (state) => ({
  fencesEditionMode: state.toggle.fencesEditionMode,
})
const mapDispatchToProps = {
  toggle: toggle,
}
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(MapTools))
